// SvgComponent.js
import React from "react";
import logoImage from "../img/Untitled-1.png";

function SvgComponent(props) {
  return <img className="logo" alt="logo" src={logoImage} />;
}

export default SvgComponent;
